const keyPressed = (provider, event) => {
    let p = provider.p;

    if (!provider.enableHotKeys) {
        let searchTab = provider.sideBar.getTab('search');
        if (p.keyCode === 27 && searchTab.focused) {
            searchTab.searchInput.elt.blur();
            return false;

        }
        provider.tools.currentTool.pressKeyHotKeysDisabled(p.keyCode);
        return;
    }

    if (onlySubKey(p.ALT, p)) {
        switch (p.keyCode) {
            case 73: // I
                provider.settings.showImage = !provider.settings.showImage;
                return false;
            case 76: // L
                provider.settings.lockLabels = !provider.settings.lockLabels;
                return false;
        }
        return provider.tools.currentTool.pressKeyWithAlt(p.keyCode);
    }

    if (onlySubKey(p.CONTROL, p)) {
        switch (p.keyCode) {
            case 83: // S
                event.preventDefault();
                provider.savePlan();
                return false;
            case 89: // Y
                event.preventDefault();
                provider.actions.redo();
                return false;
            case 90: // Z
                event.preventDefault();
                provider.actions.undo();
                return false;
        }
        return provider.tools.currentTool.pressKeyWithControl(p.keyCode);
    }

    if (onlySubKey(p.SHIFT, p)) {
        switch (p.keyCode) {
            case 69: // E
                provider.tools.setTool('erase');
                return false;
            case 71: // G
                provider.settings.showGrid = !provider.settings.showGrid;
                return false;
            case 73: // I
                provider.tools.setTool('image');
                return false;
            case 76: // L
                provider.settings.showLabels = !provider.settings.showLabels;
                return false;
            case 82: // R
                provider.view.reset();
                return false;
            case 83: // S
                provider.settings.snapToGrid = !provider.settings.snapToGrid;
                return false;
        }
        return provider.tools.currentTool.pressKeyWithShift(p.keyCode);
    }

    switch (p.keyCode) {
        case 65: // A
            provider.tools.setTool('shapes');
            return;
        case 67: // C
            provider.tools.setTool('select');
            return;
        case 69: // E
            provider.sideBar.setTab('elements');
            return;
        case 72: // H
            provider.tools.setTool('help');
            return;
        case 73: // I
            provider.sideBar.setTab('info');
            return;
        case 76: // L
            provider.sideBar.setTab('lists');
            return;
        case 78: // N
            provider.tools.setTool('navigate');
            return;
        case 80: // P
            provider.sideBar.setTab('plants');
            return;
        case 83: // S
            provider.sideBar.setTab('search');
            setTimeout(() => provider.sideBar.getTab('search').searchInput.elt.focus(), 10);
            return;
        case 187: // +
            provider.view.zoomIn();
            return;
        case 188: // ,
            provider.tools.setTool('settings');
            return;
        case 189: // -
            provider.view.zoomOut();
            return;
    }

    return provider.tools.currentTool.pressKey(p.keyCode);
}

const onlySubKey = (code, p) => {
    let subKeys = [
        p.CONTROL,
        p.SHIFT,
        p.ALT,
    ];

    return p.keyIsDown(code)
        && subKeys.filter(subKey => p.keyIsDown(subKey)).length === 1;
}

let releaseSpacebar;
let releaseCount = 0;

const registerSpacebarListeners = (provider) => {
    document.body.addEventListener('keydown', (event) => {
        if (event.code === 'Space' && provider.enableHotKeys) {
            provider.tools.setTool('navigate');
            clearTimeout(releaseSpacebar);
        }
    });

    document.body.addEventListener('keyup', (event) => {
        if (event.code === 'Space' && provider.enableHotKeys) {
            releaseSpacebar = setTimeout(() => {
                provider.tools.setPreviousTool();
                releaseCount = 0;
            }, releaseCount > 0 ? 50 : 510);
            // When holding the spacebar it first registers a keydown, then quickly after a keyup.
            // but it then takes almost half a second to register a second keydown and keyup. After
            // which they quickly alternate. Because we want a fast response time when releasing the
            // spacebar we want the timeout to be short (50ms), but because the second keydown comes
            // so late, we need to set the timeout longer for the first keydown event (500ms). Otherwise it
            // would switch off before turning on again at the second keydown event.
            releaseCount++;
        }
    });
}

export { keyPressed, registerSpacebarListeners };
